export class EmailConfirm {
  EMail: string = null;
  Id_Session: string = null;
  Id_User: number = null;
  Message: string = null;
  Region: string = null;
  ReturnCode: number = null;
  Sex: boolean = null;
  Value: any = null;
  Value2: any = null;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/email-cinfirm-model.ts